import { getFieldValue } from '../utils';
import { businessOptikTvFieldNames } from '../../utils/constant';
import { getLocale } from '../../misc';
import EN from '../../../EN.json';
import FR from '../../../FR.json';

const BusinessOptikTvHelpers = ({
  fieldName,
  formFields,
  fields
}) => {
  const locale = getLocale();

  // Get translations
  const translations = locale === 'en-US' ? EN : FR;

  // Destructure translation values
  const {
    businessOptikTv: {
      privateHomeBasedBusinessOpus,
      publicOpus,
      privateLegacy,
      publicLegacy,
      publicLiquor,
      monthToMonth,
      thirtySixMonths,
      basicsBtl,
      core,
      choices,
      moreChoices,
      optikTvBasic,
      optikTv,
      optikTvElite
    },
    yes,
    no
  } = translations.vulcanWebform;

  const {
    customerLiquorLicenseVul,
    profileTypeOptikTvVul,
    termBusinessOptikTvVul,
    monthlyRatePlanOptikTvVul
  } = businessOptikTvFieldNames;

  // Get current field values
  const liquorLicenseValue = getFieldValue(
    customerLiquorLicenseVul,
    formFields
  );
  const profileTypeValue = getFieldValue(profileTypeOptikTvVul, formFields);
  const termValue = getFieldValue(termBusinessOptikTvVul, formFields);

  // Handle Profile Type filtering based on Liquor License
  if (fieldName === profileTypeOptikTvVul) {
    if (liquorLicenseValue === yes) {
      // If liquor license = Yes, show only Public options
      fields.options = formFields[profileTypeOptikTvVul].options.filter(
        option =>
          option.fields.value === publicOpus ||
          option.fields.value === publicLegacy ||
          option.fields.value === publicLiquor
      );
    } else if (liquorLicenseValue === no) {
      // If liquor license = No, show all except Public (Legacy)
      fields.options = formFields[profileTypeOptikTvVul].options.filter(
        option => ![publicLegacy, publicLiquor].includes(option.fields.value)
      );
    } else {
      // If liquor license field is hidden or has no value, show all options (default state)
      fields.options = formFields[profileTypeOptikTvVul].options;
    }
  }

  // Handle Term filtering based on Profile Type
  if (fieldName === termBusinessOptikTvVul) {
    if (
      profileTypeValue === publicLegacy ||
      profileTypeValue === privateLegacy
    ) {
      // Legacy profiles only show Month to Month
      fields.options = formFields[termBusinessOptikTvVul].options.filter(
        option => option.fields.value === monthToMonth
      );
    } else {
      // If profile type is not Legacy, show all term options (default state)
      fields.options = formFields[termBusinessOptikTvVul].options;
    }
  }

  // Handle Monthly Rate Plan filtering based on Profile Type
  if (fieldName === monthlyRatePlanOptikTvVul) {
    let updateOption = formFields[monthlyRatePlanOptikTvVul].options;
    if (
      profileTypeValue === privateLegacy ||
      profileTypeValue === publicLegacy
    ) {
      // Legacy profiles show Legacy rate plans
      updateOption = formFields[
        monthlyRatePlanOptikTvVul
      ].options.filter(option =>
        [optikTvBasic, optikTv, optikTvElite].includes(option.fields.value)
      );
    } else if (
      profileTypeValue === privateHomeBasedBusinessOpus ||
      profileTypeValue === publicOpus ||
      profileTypeValue === publicLiquor
    ) {
      // OPUS profiles show OPUS rate plans (including Basics (BTL) for both Month to Month and 36 Months)
      updateOption = formFields[
        monthlyRatePlanOptikTvVul
      ].options.filter(option =>
        [basicsBtl, core, choices, moreChoices].includes(option.fields.value)
      );
    }

    fields.options = updateOption;
  }

  // Handle conditional field visibility and requirements
  if (fieldName === termBusinessOptikTvVul) {
    if (
      profileTypeValue === publicLegacy ||
      profileTypeValue === privateLegacy
    ) {
      // Legacy profiles only show Month to Month
      fields.isVisible = true;
      fields.isRequired = true;
    } else if (
      profileTypeValue === privateHomeBasedBusinessOpus ||
      profileTypeValue === publicOpus
    ) {
      // OPUS profiles show both options
      fields.isVisible = true;
      fields.isRequired = true;
    }
  }

  if (fieldName === monthlyRatePlanOptikTvVul) {
    if (profileTypeValue) {
      // Only show rate plan field if profile type is selected
      fields.isVisible = true;
      fields.isRequired = true;
    } else {
      // Hide rate plan field if no profile type selected
      fields.isVisible = false;
      fields.isRequired = false;
    }
  }
};

export default BusinessOptikTvHelpers;
